import { render, staticRenderFns } from "./ImageIcon.vue?vue&type=template&id=6f870840&scoped=true"
import script from "./ImageIcon.vue?vue&type=script&lang=ts"
export * from "./ImageIcon.vue?vue&type=script&lang=ts"
import style0 from "./ImageIcon.vue?vue&type=style&index=0&id=6f870840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f870840",
  null
  
)

export default component.exports